module.exports = __webpack_public_path__ + "static/img/show-toast-info.a7f32c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/show-toast-info.png
// module id = JUVB
// module chunks = 6